/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkElectricalMeasurementType } from '../models/work-electrical-measurement-type';

@Injectable({ providedIn: 'root' })
export class WorkElectricalmeasurementtypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `electricalMeasurementTypesV2ControllerGetAllDropdownOptions()` */
  static readonly ElectricalMeasurementTypesV2ControllerGetAllDropdownOptionsPath = '/v2/electricalmeasurementtypes/dropdown-options';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementTypesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementTypesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalmeasurementtypesV2Service.ElectricalMeasurementTypesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementTypesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementTypesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.electricalMeasurementTypesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementTypesV2ControllerFindAll()` */
  static readonly ElectricalMeasurementTypesV2ControllerFindAllPath = '/v2/electricalmeasurementtypes/all';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementTypesV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementTypesV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkElectricalMeasurementType>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalmeasurementtypesV2Service.ElectricalMeasurementTypesV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkElectricalMeasurementType>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementTypesV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementTypesV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkElectricalMeasurementType>> {
    return this.electricalMeasurementTypesV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkElectricalMeasurementType>>): Array<WorkElectricalMeasurementType> => r.body)
    );
  }

  /** Path part for operation `electricalMeasurementTypesV2ControllerFindOneById()` */
  static readonly ElectricalMeasurementTypesV2ControllerFindOneByIdPath = '/v2/electricalmeasurementtypes/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `electricalMeasurementTypesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementTypesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkElectricalMeasurementType>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElectricalmeasurementtypesV2Service.ElectricalMeasurementTypesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkElectricalMeasurementType>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `electricalMeasurementTypesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  electricalMeasurementTypesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkElectricalMeasurementType> {
    return this.electricalMeasurementTypesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkElectricalMeasurementType>): WorkElectricalMeasurementType => r.body)
    );
  }

}
